import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { StructureOrganizative, CacheService, ITypeStateNodeBO } from '@mapfre-tech/amap3';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
   providedIn: "root"
})
export class TypesStateNodesService {

   className = 'TypesStateNodesService';

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAll(cache = true, cacheKey = "allTypeStateNodesService"): Observable<ITypeStateNodeBO[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeStateNodeBO[]>;
       } else {
         const observable = this.http.get<ITypeStateNodeBO[]>(environment.base_URL + "/types-state-nodes/").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

}
